import { default as i18n } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import numbro from 'numbro'
import { initReactI18next } from 'react-i18next'
import { HashedHttpBackend } from './backends'
import { initOptions } from './config'

i18n.use(initReactI18next)
  .use(HttpApi)
  .use(new HashedHttpBackend())
  .use(LanguageDetector)
  .init(initOptions)

i18n.on('languageChanged', (language) => {
  numbro.setLanguage(language)
})
